import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ContactGroupPermissionGate = (props: Omit<BasePermissionGateProps<"contact">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="contact"
		/>
	)
}

export default ContactGroupPermissionGate
